<template>
  <b-container fluid class="d-flex align-items-stretch pt-5">
    <b-row class="flex-grow-1 d-flex align-items-stretch">

      <b-col cols="10" offset="1" class="mb-5">
        <b-input-group class="search-bar">
          <!-- Attach Left button Group via slot -->
          <b-select v-model="searchMode" :options="modeOptions" class="bg-success text-white" slot="prepend"></b-select>

          <!-- Main form input -->
          <b-form-input v-model="input" @input="handleInput" placeholder="E.g. Te O" class="bg-white">
          </b-form-input>
          <span id="searchclear" @click="handleClear">
            <icon name="close"></icon>
          </span>

          <!-- Attach Right button Group via slot -->
          <b-btn @click="handleSearch" variant="primary" slot="append" 
            class="text-white" :disabled="!isValid">Search</b-btn>
        </b-input-group>
        <div class="input-warning">
          <span class="text-danger"> {{ warning }} </span>
        </div>

        <PTable full class="mx-auto mb-5" :value="elems" @input="handlePTInput"></PTable>
        <div id="scroll-point"></div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from 'vue'
import PTable from './PTable/PTable.vue'
import {symbolToObj} from './PTable/PTableData.js'

function parseElems (str) {
  let elems = []
  // console.log('parseElems: ', str)
  str.split(/\s+/).forEach(item => {
    item = item.trim()
    if (item !== '' && !elems.includes(item)) {
      elems.push(item)
    }
  })
  return elems
}

function getDefaultData () {
  return {
    selectedSg: [],
    oldpath: '',
    excl: '',
    nsite: null,
    nelem: null,
    elems: [],
    sgNums: [...Array(230).keys()].map(i => { return i + 1 }),
    nsoc_gap_min: null,
    soc_gap_min: null,
    searchMode: 'exact',
    modeOptions: [
      {value: 'exact', text: 'Exactly Match Elements'},
      {value: 'include', text: 'Include Elements'}
    ],
    topClass: null,
    topClassOptions: [
      {value: null, text: 'Make selection'},
      {value: 'GM_SM', text: 'Generic momentum semi-metal'},
      {value: 'TI', text: 'Topological insulator'},
      {value: 'TCI', text: 'Topological crystalline insulator'},
      {value: 'nsoc_HSP_SM', text: 'Non-SOC high symmetry point semi-metal'},
      {value: 'nsoc_HSL_SM', text: 'Non-SOC high symmetry line semi-metal'},
      {value: 'soc_HSP_SM', text: 'SOC high symmetry point semi-metal'},
      {value: 'soc_HSL_SM', text: 'SOC high symmetry line semi-metal'}
    ],
    socIndGroups: [
      {
        inds: [{label: 'Z2', val: '*'}, {label: 'Z2', val: '*'}, {label: 'Z2', val: '*'}, {label: 'Z4', val: '*'}],
        gids: [2, 10, 47, 11, 12, 13, 49, 51, 65, 67, 69, 14, 15, 48, 50, 53, 54, 55, 57, 59, 63, 64, 66, 68, 71, 72, 73, 74, 84, 85, 86, 125, 129, 131, 132, 134, 147, 148, 162, 164, 166, 200, 201, 204, 206, 224],
        selected: true
      }, {
        inds: [{label: 'Z4', val: '*'}],
        gids: [52, 56, 58, 60, 61, 62, 70, 88, 126, 130, 133, 135, 136, 137, 138, 141, 142, 163, 165, 167, 202, 203, 205, 222, 223, 227, 228, 230],
        selected: true
      }, {
        inds: [{label: 'Z2', val: '*'}],
        gids: [81, 82, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 215, 216, 217, 218, 219, 220],
        selected: true
      }, {
        inds: [{label: 'Z2', val: '*'}, {label: 'Z4', val: '*'}, {label: 'Z8', val: '*'}],
        gids: [83, 123],
        selected: true
      }, {
        inds: [{label: 'Z2', val: '*'}, {label: 'Z8', val: '*'}],
        gids: [87, 124, 139, 140, 229],
        selected: true
      }, {
        inds: [{label: 'Z4', val: '*'}, {label: 'Z8', val: '*'}],
        gids: [127, 221],
        selected: true
      }, {
        inds: [{label: 'Z8', val: '*'}],
        gids: [128, 225, 226],
        selected: true
      }, {
        inds: [{label: 'Z3', val: '*'}, {label: 'Z3', val: '*'}],
        gids: [174, 187, 189],
        selected: true
      }, {
        inds: [{label: 'Z3', val: '*'}],
        gids: [188, 190],
        selected: true
      }, {
        inds: [{label: 'Z6', val: '*'}, {label: 'Z12', val: '*'}],
        gids: [175, 191],
        selected: true
      }, {
        inds: [{label: 'Z12', val: '*'}],
        gids: [192, 176, 193, 194],
        selected: true
      }
    ],
    nsocIndGroups: [
      {
        inds: [{label: 'Z2', val: '*'}, {label: 'Z2', val: '*'}, {label: 'Z2', val: '*'}, {label: 'Z4', val: '*'}],
        gids: [2, 12, 13, 15, 147, 148],
        selected: true
      }, {
        inds: [{label: 'Z2', val: '*'}, {label: 'Z2', val: '*'}, {label: 'Z2', val: '*'}],
        gids: [10, 175, 83],
        selected: true
      }, {
        inds: [{label: 'Z2', val: '*'}, {label: 'Z2', val: '*'}],
        gids: [81, 84, 87],
        selected: true
      }, {
        inds: [{label: 'Z2', val: '*'}],
        gids: [11, 14, 48, 49, 50, 52, 53, 54, 56, 58, 60, 66, 68, 70, 162, 163, 164, 165, 166, 167, 176, 192, 85, 86, 88, 124, 128, 130, 201, 203,
          3, 75, 77, 168, 171, 172, 27, 37, 103, 184, 82],
        selected: true
      }
    ],
    input: '',
    isValid: true,
    warning: '',
    data: {},
    showTable: false,
    queryNow: true,
    filterKey: 0,
    loading: false
  }
}

export default {
  name: 'Search',

  components: {
    PTable
  },

  data: getDefaultData,

  computed: {
    query () {
      let query = {}
      if (this.searchMode === 'include' && this.elems.length) {
        query['elements[incl]'] = this.elems.join(',')
      } else if (this.searchMode === 'exact' && this.elems.length) {
        query['elements[no_order]'] = this.elems.join(',')
      }
      if (this.excl) {
        query['elements[excl]'] = this.excl.split(/\s+/).join(',')
      }
      if (this.selectedSg.length) {
        query['spacegroup.number[in]'] = this.selectedSg.join(',')
      }
      if (this.nelem) {
        query['nelem[gte]'] = this.nelem[0]
        query['nelem[lte]'] = this.nelem[1]
      }
      if (this.nsite) {
        query['nsites[gte]'] = this.nsite[0]
        query['nsites[lte]'] = this.nsite[1]
      }
      if (this.topClass) {
        if (this.topClass === 'GM_SM') {
          query['nsoc_topo_class'] = this.topClass
        } else if (['TI', 'TCI'].includes(this.topClass)) {
          query['soc_topo_class'] = this.topClass
        } else if (['nsoc_HSP_SM', 'nsoc_HSL_SM'].includes(this.topClass)) {
          query['nsoc_topo_class'] = this.topClass.substring(5)
        } else if (['soc_HSP_SM', 'soc_HSL_SM'].includes(this.topClass)) {
          query['soc_topo_class'] = this.topClass.substring(4)
        }
      }
      if (this.nsoc_gap_min !== null && this.nsoc_gap_min !== '') {
        query['nsoc_dos_gap[gte]'] = this.nsoc_gap_min
      }
      if (this.soc_gap_min !== null && this.soc_gap_min !== '') {
        query['soc_dos_gap[gte]'] = this.soc_gap_min
      }
      let igs = {}
      if (this.topClass === 'GM_SM') {
        let qig = false
        this.nsocIndGroups.forEach(ig => {
          if (this.validNsocGroups.includes(this.getIndGroupId(ig))) {
            if (!ig.selected) {
              qig = true
            } else {
              igs[this.getIndGroupId(ig)] = ig.inds.map(ind => {
                if (ind.val !== '*') {
                  qig = true
                }
                return ind.val
              })
            }
          }
        })
        if (qig) {
          query['nsoc_ind'] = igs
        }
      } else if (this.topClass === 'TI' || this.topClass === 'TCI') {
        igs = {}
        let qig = false
        this.socIndGroups.forEach(ig => {
          if (this.validSocGroups.includes(this.getIndGroupId(ig))) {
            if (!ig.selected) {
              qig = true
            } else {
              igs[this.getIndGroupId(ig)] = ig.inds.map(ind => {
                if (ind.val !== '*') {
                  qig = true
                }
                return ind.val
              })
            }
          }
        })
        if (qig) {
          query['soc_ind'] = igs
        }
      }
      return query
    },

    validSocGroups () {
      return this.validGroups(this.socIndGroups)
    },

    validNsocGroups () {
      return this.validGroups(this.nsocIndGroups)
    }
  },

  methods: {
    validGroups (indGroups) {
      if (this.selectedSg.length === 0) {
        return indGroups.map(ig => { return this.getIndGroupId(ig) })
      }
      let rtn = []
      this.selectedSg.forEach(gid => {
        indGroups.forEach(ig => {
          if (ig.gids.includes(gid)) {
            rtn.push(this.getIndGroupId(ig))
          }
        })
      })
      return rtn
    },

    getIndGroupId (ig) {
      return ig.inds.map(ind => { return ind.label }).join('_')
    },

    formatInput (str, e) {
      let elems = []
      str.split(/[^a-zA-Z]+/).forEach(item => {
        item = item.charAt(0).toUpperCase() + item.substr(1).toLowerCase()
        elems.push(item)
      })
      return elems.join(' ')
    },

    handleInput (str) {
      this.elems = parseElems(str)
    },

    handlePTInput (elems) {
      // console.log('PTInput: ', elems)
      this.elems = elems
      this.input = elems.join(' ')
    },

    handleClear () {
      this.input = ''
      this.elems = []
    },

    handleSearch () {
      this.queryServer(this.query)
      this.queryNow = false
      this.$router.push({name: 'searchResults', query: this.query})
    },

    queryServer (query) {
      // console.log('query server', query)
      let keys = ['includeElem', 'excludeElem', 'exactElem', 'sgNum']
      keys.forEach(key => {
        if (query[key] && !Array.isArray(query[key])) {
          query[key] = [query[key]]
        }
      })
      // console.log(query)
      this.loading = true
      this.showTable = false
      document.getElementById('scroll-point').scrollIntoView()
      this.axios.get('/materials/search', { params: query })
      .then(res => {
        this.data = res.data
        this.loading = false
        this.showTable = true
        let that = this
        Vue.nextTick()
          .then(function () {
            // document.getElementById('scroll-point').scrollIntoView()
            that.filterKey += 1 // force the filter area component to be recreated to fix the partial background problem
          })
      })
      .catch(error => {
        console.log(error.response)
      })
    },

    reset () {
      this.loading = false
      // console.log('resetting')
      this.$router.push('/search')
      Object.assign(this.$data, getDefaultData())
    }

  },

  watch: {
    '$route' (to, from) {
      // console.log('route changed!')
      if (to.name === 'search') {
        this.reset()
      }
      // console.log(to.name, to.fullPath, this.oldPath)
      if (to.name === 'searchResults' && to.fullPath !== this.oldPath && this.queryNow) {
        this.queryServer(to.query)
        this.oldPath = to.fullPath
      }
      this.queryNow = true
    },

    elems (value) {
      let invalidElems = []
      value.forEach(item => {
        if (symbolToObj(item) === undefined) {
          invalidElems.push(item)
        }
      })
      // console.log('invalidElems: ', invalidElems)
      if (invalidElems.length === 0) {
        this.isValid = true
        this.warning = ''
      } else {
        this.isValid = false
        this.warning = 'invalid input: ' + invalidElems.join(', ')
      }
    }
  },

  mounted () {
    this.oldPath = this.$route.fullPath
    if (this.$route.name === 'searchResults') {
      this.queryServer(this.$route.query)
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
